<div class="main-container">
  <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/name-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">Filtrar actividades</h4><h6 class="color-gray" style="font-weight: 400;">Selecciona los criterios para filtrar la vista de actividades.</h6></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>

    <form>
   
      <div class="filter-section">
        <label class="section-title">Intervalo de fechas</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="dateRange" [(ngModel)]="filters.dateRange" value="2m">
            <span class="crm-radio-custom"></span>
            En 2 meses
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="dateRange" [(ngModel)]="filters.dateRange" value="30d">
            <span class="crm-radio-custom"></span>
            Últimos 30 días
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="dateRange" [(ngModel)]="filters.dateRange" value="7d-next">
            <span class="crm-radio-custom"></span>
            Próximo 7 días
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="dateRange" [(ngModel)]="filters.dateRange" value="6m">
            <span class="crm-radio-custom"></span>
            Últimos 6 meses
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="dateRange" [(ngModel)]="filters.dateRange" value="7d">
            <span class="crm-radio-custom"></span>
            Últimos 7 días
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="dateRange" [(ngModel)]="filters.dateRange" value="all">
            <span class="crm-radio-custom"></span>
            Siempre
          </label>
        </div>
      </div>

     
      <div class="filter-section">
        <label class="section-title">Actividades que mostrar</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="activitieRange" [(ngModel)]="filters.activityView" value="all">
            <span class="crm-radio-custom"></span>
            Todas las actividades
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="activitieRange" [(ngModel)]="filters.activityView" value="mine">
            <span class="crm-radio-custom"></span>
            Mis actividades
          </label>
        </div>
      </div>

      
      <div class="filter-section">
        <label class="section-title">Tipo de actividad</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allTypes" name="allTypes" (change)="toggleAllTypes()">
            <span class="crm-checkbox-custom"></span>
            Todos los tipos
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.types.email" name="email" (change)="onTypeChange()">
            <span class="crm-checkbox-custom"></span>
            Correo
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.types.listEmail" name="listEmail" (change)="onTypeChange()">
            <span class="crm-checkbox-custom"></span>
            Correos de lista
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.types.calls" name="calls" (change)="onTypeChange()">
            <span class="crm-checkbox-custom"></span>
            Llamadas registradas
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.types.tasks" name="tasks" (change)="onTypeChange()">
            <span class="crm-checkbox-custom"></span>
            Tareas
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.types.events" name="events" (change)="onTypeChange()">
            <span class="crm-checkbox-custom"></span>
            Eventos
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Estado de la actividad</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allStatuses" name="allStatuses" (change)="toggleAllStatuses()">
            <span class="crm-checkbox-custom"></span>
            Todos los estados
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.pendiente" name="pendiente" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            Pendiente
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.enProgreso" name="enProgreso" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            En progreso
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.completada" name="completada" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            Completada
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.vencida" name="vencida" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            Vencida
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.programada" name="programada" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            Programada
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.statuses.cancelada" name="cancelada" (change)="onStatusChange()">
            <span class="crm-checkbox-custom"></span>
            Cancelada
          </label>
        </div>
      </div>

      <hr style="margin-top: 24px;">

      <div class="filter-actions">
        <button type="button" class="btn btn-primary-outline" (click)="closeMdl()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="applyFilters()">Aplicar filtros</button>
      </div>
    </form>
  </div>
</div>